angular.module('picmonicng').component('ambassadorPortalComponent', {
  templateUrl: '/templates/app/pages/ambassador-portal/ambassador-portal.html',
  bindings: {},
  controller: [
    'UserService',
    'User',
    'MarketOptionsConfig',
    'affiliateResource',
    '$filter',
    'toaster',
    '$stateParams',
    '$http',
    '$anchorScroll',
    function (
      UserService,
      User,
      MarketOptionsConfig,
      affiliateResource,
      $filter,
      toaster,
      $stateParams,
      $http,
      $anchorScroll
    ) {
      const promotionalFrom = new Date('11/09/2021').setUTCHours(0, 0, 0, 0);
      const promotionalTo = new Date('12/02/2021').setUTCHours(23, 59, 59, 999);
      const now = new Date().getTime();
      const amazonGiftCardAmount = '$5';
      const promoAmazonGiftCardAmount = '<del>$5</del> $10';

      const ctrl = this;
      ctrl.now = now;
      ctrl.userAgent = navigator.userAgent;
      ctrl.UserService = UserService;
      ctrl.user_count = window.pls_config.user_count;
      ctrl.redeem_email = UserService.user.email;
      ctrl.isAdmin = !!$stateParams.is_admin;
      ctrl.market_school = MarketOptionsConfig.getMarketById(UserService.user.lead).school_name;
      ctrl.showPromotional = now >= promotionalFrom && now <= promotionalTo;

      ctrl.navItemSelected = 'sharelink';
      ctrl.navItems = [
        { id: 'sharelink', name: 'Share Your Link' },
        { id: 'howitworks', name: 'How It Works' },
        { id: 'yourstats', name: 'Your Stats' },
        { id: 'yourreferralhistory', name: 'Your Referral History' },
        { id: 'extrabonuses', name: 'Extra Bonuses' },
        { id: 'itseasytogetstarted', name: 'Get Started' },
        { id: 'hashtaglibrary', name: 'Hashtag Library' },
        { id: 'talkingpoints', name: 'Talking Points' },
        {
          id: 'learnmoreaboutpicmonic',
          name: 'Learn More About Picmonic',
        },
        { id: 'gethelp', name: 'Get Help' },
      ];

      if (ctrl.isAdmin) {
        ctrl.referrals = {};
        $http.get('/api/v3/admin/users/' + $stateParams.id + '/referrals').then(function (referrals) {
          ctrl.referrals = referrals.data;
        });
        ctrl.affiliate = {};
        $http.get('/api/v3/admin/users/' + $stateParams.id + '/affiliate_portal').then(function (data) {
          ctrl.affiliate = data.data;
        });
        ctrl.hide_share = true;
      } else {
        ctrl.referrals = User.get({ resource: 'referrals' });
        ctrl.affiliate = affiliateResource.get();
      }

      ctrl.redeemRewards = function () {
        if (
          ctrl.referrals.total_redeemable_balance &&
          !ctrl.loading_redeem &&
          confirm('Are you sure you want to request your rewards be sent to ' + ctrl.redeem_email + '?')
        ) {
          ctrl.loading_redeem = true;
          User.post(
            {
              resource: 'referrals',
              resource_id: 'redeem',
              email: ctrl.redeem_email,
            },
            function () {
              ctrl.referrals = User.get({
                resource: 'referrals',
              });
              ctrl.referrals.$promise.then(function () {
                toaster.success('Reward successfully requested! Check your inbox within 24 hours.');
                ctrl.loading_redeem = false;
              });
            },
            function (response) {
              ctrl.loading_redeem = false;
              toaster.error(response.data.message);
            }
          );
        }
      };

      $anchorScroll.yOffset = 16;

      ctrl.selectAnchor = function (anchor) {
        ctrl.navItemSelected = anchor;
        $anchorScroll(anchor);
      };

      ctrl.base_asset_url = window.pls_config.base_asset_url.substring(
        window.pls_config.base_asset_url.indexOf('/cloud_data')
      );

      if (!UserService.user.tos_accepted) {
        UserService.showTOSModal();
      }

      /**
       * Retrieves the Amazon Gift Card dollar amount
       */
      ctrl.getAmazonGiftCardAmount = function () {
        if (ctrl.showPromotional) {
          return promoAmazonGiftCardAmount;
        }

        return amazonGiftCardAmount;
      };
    },
  ],
});
